
import { defaultTo, complement, either, isNil, equals } from 'ramda';
import { createValidator, validate, stringRequired, EventHooks } from './index';
import { uuidv4, subscribeSubject, debounceFunction } from '../../utility';
import { Subject } from 'rxjs';



export const TextFieldMixin = () => {
  return {
    props: {
      _id: {
        default: () => uuidv4()
      },
      id: {
        required: true
      },
      rightIcon: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
      },
      value: {
      },
      maximizeOnValue: {
        type: Boolean,
        default: true
      },
      height: {
        type: Number,
        default: 42
      },
      showEditIconOnHover: {
        type: Boolean,
        default: false
      },
      searchIcon: {
        type: String,
        default: ''
      },
      searchLinkText: {
        type: String,
        default: 'Search'
      },
      box: {
        type: Boolean,
        default: true
      },
      showValidationIcons: {
        type: Boolean,
        default: false
      },
      validationEvent: {
        type: String,
        default: EventHooks.OnKeyup
      },
      valueChangedEvent: {
        type: String,
        default: EventHooks.OnKeyup
      },
      validators: {
        type: Array,
        default: () => []
      },
      required: {
        type: Boolean,
        default: false
      },
      password: {
        type: Boolean,
        default: false
      },
      isModel: {
        type: Boolean,
        default: false
      },
      textarea: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      },
      typeahead: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array
      },
      disabled: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      statusInside: {
        type: Boolean,
        default: false
      },
      immediateValidation: {
        type: Boolean,
        default: false
      },
      controlStyle: {
        type: String,
        default: 'box'
      },
      autocomplete: {
        type: String,
        default: "on"
      },
      canReset: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
    },
    mounted: async function () {
      // this._id = uuidv4();
      // console.log(this._id);
      let dateMutationObserver;
      let headerButtonList = [], dateButtonList = [];

      subscribeSubject(this, this.pickerSubject, (value) => {
        this.pickerMenu = value;
        // console.log("Subject -> this.pickerMenu value ", this.pickerMenu)

        if (this.pickerMenu && this.isPickerType) {
          this.$nextTick(() => {

            this.$refs['datePickerContainer']?.addEventListener?.('click', this.datePickerClickListener, true);

            // dateMutationObserver = new MutationObserver((mutations) => {
            //   assignEvents();
            //   // mutations.forEach((mutation) => {
            //   //   // console.log(mutation);
            //   // });
            // });
            // dateMutationObserver.observe(datePickerContainer, {
            //   attributes: false,
            //   characterData: false,
            //   childList: true,
            //   subtree: true,
            //   attributeOldValue: false,
            //   characterDataOldValue: false
            // });

            // const assignEvents = debounceFunction(() => {
            //   console.log(`assignEvents HeaderButtons `);
            //   const headerButtonEvent = event => {
            //     datePickerContainer.focus();
            //     console.log('this.onPickerClick();');
            //     this.onPickerClick();

            //     this.$nextTick(() => {
            //       // console.log('Assigning events to Date Buttons');


            //       // console.log("Log: assignEvents -> dateButtonList", dateButtonList)
            //       dateButtonList?.map(db => db.removeEventListener?.('click', dateButtonEvent));

            //       const dateButtons = datePickerContainer.querySelectorAll('.date-picker-table--date td>button');
            //       dateButtonList.push(...dateButtons);
            //       for (let button of dateButtons) {

            //         button.addEventListener('click', dateButtonEvent);
            //       }
            //     });
            //   }
            //   const dateButtonEvent = event => {
            //     event.stopPropagation();
            //   };

            //   // console.log("Log: assignEvents -> headerButtonList", headerButtonList)
            //   headerButtonList?.map(hb => hb.removeEventListener?.('click', headerButtonEvent));

            //   const headerButtons = datePickerContainer.querySelectorAll('.date-picker-header>button');
            //   headerButtonList.push(...headerButtons);
            //   for (let button of headerButtons) {
            //     button.addEventListener('click', headerButtonEvent);
            //   }
            //   // console.log('Assigning events to Date Buttons');

            //   dateButtonList?.map(db => db.removeEventListener?.('click', dateButtonEvent));
            //   const dateButtons = datePickerContainer.querySelectorAll('.date-picker-table--date td>button');
            //   dateButtonList.push(...dateButtons);

            //   for (let button of dateButtons) {
            //     button.addEventListener('click', event => {
            //       event.stopPropagation();

            //     });
            //   }
            // });

            // assignEvents();

          })
        } else {
          dateMutationObserver?.disconnect();
          this.datePickerClickListener && this.$refs['datePickerContainer']?.removeEventListener?.('click', this.datePickerClickListener, true);
          if (this.$refs['datePickerContainer']) {
            // console.log('remove Ev', this.$refs['datePickerContainer']);
          }
        }

      }, 200)
    },
    data: function () {
      return {
        maximized: false,
        outlined: false,
        focused: false,
        textInputValue: '',
        validatorsMap: {},
        touched: false,
        validationResult: {
          valid: true,
          errors: [],
          errorMessages: []
        },
        typeaheadMenu: false,
        pickerMenu: false,

        RO_write: false,

        pickerSubject: new Subject(),
      }
    },
    watch: {
      required: {
        immediate: true,
        handler: function (newValue, oldValue) {
          if (newValue) {
            this.validatorsMap['required'] = createValidator({
              name: 'required',
              validatorFn: stringRequired,
              errorMessage: `${this.placeholder} Can't be empty`
            });
          }
        }
      },
      validators: {
        immediate: true,
        handler: function (newValue, oldValue) {
          newValue.forEach(val => {
            this.validatorsMap[val.name] = val;
          });
        }
      },
      value: {
        immediate: true,
        handler: function (newVal, oldVal) {
          // console.log('val in', newVal, this.id);
          this.textInputValue = newVal;
          this.maximized = this.maximizeOnValue ?
            (isValidValue(newVal) ? true : (this.focused ? true : false))
            : false;

          this.validateInput(newVal);
        }
      }
    },
    created: function () {
      this.maximized = this.maximizeOnValue ?
        (isValidValue(this.value) ? true : false)
        : false;
    },
    methods: {
      onOptionClicked: function (option) {
        this.setTypeahead(false);
        this.emitSelected(option);
        // this.setValue(option.text);
      },
      onEditClick: function (e) {
        if (this.disabled) {
          return;
        }
        if (!this.isReadonly) {
          this.startEditing();
        } else if (this.isReadonlyWrite) {
          this.startEditing();
        }

        setTimeout(() => {
          // !Change This later
          // document.getElementById(this.inputId).focus();
          // console.log(this.$refs['input_element']);
          this.$refs['input_element'].focus();
        }, 100)
      },
      onSearchClick: function (e) {
        this.$emit('searchClick', { name: this.id, value: this.textInputValue });
      },
      onTextInputKeyup: function (e) {
        this.setValue(e.target.value);
        this.setTypeahead(true);

        // Emitting Keyup Event, So any host COmponent can check up on Escape or Enter or other Key up settings
        this.$emit('keyup', e);
      },
      setValue: function (value) {
        this.textInputValue = value;
        // console.log("Log: TextFieldMixin -> this.textInputValue", this.textInputValue, this.validationEvent);

        if (this.validationEvent == EventHooks.OnKeyup) {
          this.touched = true;
          this.validateInput(this.textInputValue);
        }

        if (this.valueChangedEvent == EventHooks.OnKeyup) {
          this.emitValue();
        }
      },
      setTypeahead: function (value) {
        if (this.typeahead) {
          this.typeaheadMenu = value;
        } else {
          this.typeaheadMenu = false;
        }
      },
      setPicker: function (value) {
        if (this.isPickerType) {
          // this.pickerMenu = value;
          this.pickerSubject.next(value);
        } else {
          this.pickerMenu = false;
        }
      },
      onTextInputFocus: function (e) {
        this.focused = true;
        this.setPicker(true);
        if (this.touched) {
          this.setTypeahead(true);
        }
        this.startEditing();

      },
      startEditing: function () {
        this.maximized = true;
        this.outlined = true;
        this.emitStartEditing();
      },
      emitStartEditing: function () {
        this.$emit('startEditing', true);
      },
      onTextInputBlur: function (e) {
        this.focused = false;
        this.setTypeahead(false);
        this.setPicker(false);
        this.textInputValue = this.isNumberType ? e.target.value.replace(',', '.') : e.target.value;
        // console.log('Text Input Blur');
        // if(this.isNumberType){
        //   this.textInputValue = this.textInputValue.replace(',', '.');
        //   console.log('Text Input Blur',this.textInputValue);
        // }
        this.outlined = false;
        this.maximized = this.maximizeOnValue ?
          (isValidValue(this.value) ? true : false)
          : false;


        if (this.validationEvent == EventHooks.OnBlur) {
          this.touched = true;
          this.validateInput(this.textInputValue);
        }

        if (this.valueChangedEvent == EventHooks.OnBlur) {
          this.emitValue();
        }


        // Emitting the blur Event as well
        this.$emit('blur', this.id, this.textInputValue);


        // console.log(this.validationResult, this.getValidatorArray());

        // if (this.validationResult.valid) {
        // }

      },
      errorMessages: function () {
        return this.validationResult.errorMessages.length > 0 ? this.validationResult.errorMessages.join(', ') : 'Error';
      },
      getValidatorArray: function () {
        return Object.keys(this.validatorsMap).map(key => {
          return {
            name: key,
            ...this.validatorsMap[key]
          };
        })
      },
      validateInput: function (value) {
        this.validationResult = validate(this.getValidatorArray())(value);
        this.$emit('validated', this.id, this.validationResult);
        // console.error(this.id, this.validationResult);
      },

      emitValue: function () {
        if (this.isModel) {
          this.$emit('input', this.textInputValue);
        }
        this.$emit('valuechanged', this.id, this.textInputValue);
      },
      emitSelected: function (option) {
        this.$emit('selected', option);
      },
      onTimeChange: function (value) {
        // console.log(value);
        this.setValue(value);
        // this.setPicker(false);
      },
      onDateChange: function (value) {
        this.setValue(value);
        this.setPicker(false);
      },
      RO_onStartChange: function () {
        this.RO_write = true;
      },

      onPickerClick: function () {
        // console.log("Log: TextFieldMixin -> onPickerClick");
        this.pickerSubject.next(true);
      },
      onPickerContainerFocus: function () {
        // console.log("Log: -> onPickerContainerFocus");
        this.pickerSubject.next(true);
      },
      onPickerContainerBlur: function () {
        // console.log("Log: onPickerContainerBlur");
        this.pickerSubject.next(false);
      },
      datePickerClickListener: function (event) {
        // console.log('click captured', event.target);
        // console.log(event.target.
        //     parentElement.
        //     parentElement.
        //     parentElement.
        //     parentElement.
        //     parentElement.
        //     parentElement.
        //     classList
        //   );
        if (event?.target?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.classList?.contains('date-picker-table--date')) {
          // console.log("pickerSUBFals");

          setTimeout(() => {
            this.setPicker(false);
          }, 100);
        } else {
          setTimeout(() => {
            this.$refs['datePickerContainer']?.focus?.();
          }, 100);
        }
      },
      onInputChange: function (event) {
        // console.log('onInputChange', event);
        // if(this.isNumberType){
        //   event.target.value.replace(',', '.');

        // }
        this.setValue(this.isNumberType ? event.target.value.replace(',', '.') : event.target.value);
      },

      onClearDateClick: function () {
        this.setValue('');
        this.setPicker(false);
      }
      //MARK: Methods
    },
    computed: {
      inputId: function () {
        return 'text_input_' + defaultTo(this.placeholder, this.id);
      },
      inputType: function () {
        if (this.password) {
          return 'password';
        } else {
          return 'text';
        }
      },
      heightComputed: function () {
        if (this.textarea) {
          if (this.height > 42) {
            return `${this.height}px`;
          } else {
            return `135px`;
          }
        } else {
          return `${this.height}px`;
        }
      },
      waitedFocus: function () {
        setTimeout(() => {
          return this.focus;
        }, 10);
      },
      isTimeType: function () {
        return this.type === 'time';
      },
      isDateType: function () {
        return this.type === 'date';
      },
      isNumberType: function () {
        return this.type === 'number';
      },
      isPickerType: function () {
        return this.isTimeType || this.isDateType;
      },
      isReadonly: function () {
        return this.controlStyle === 'readonly';
      },
      onlyReadonly: function () {
        return this.isReadonly && !this.onlyIfReadonlyWrite;
      },
      onlyIfReadonlyWrite: function () {
        return this.isReadonly ? this.RO_write : false;
      },
      isReadonlyWrite: function () {
        return this.isReadonly ? this.RO_write : true;
      },
      controlDisabled: function () {
        return this.disabled || this.onlyReadonly;
      },
      controlReadonly: function () {
        return this.readonly || this.isDateType;
      }
    }
  }
}

const isValidValue = complement(either(
  isNil,
  equals('')
));


